import { Component } from '@angular/core';
import { CommonService } from '../../shared/common/common.service';
import { NgClass } from '@angular/common';
import { CommonStandaloneImports } from '../../shared/common/common-standalone-imports';

@Component({
  selector: 'app-terms-condition',
  imports: [NgClass, ...CommonStandaloneImports],
  standalone: true,
  templateUrl: './terms-condition.html',
  styleUrl: './terms-condition.scss',
})
export class TermsConditionComponent {
  constructor(
    public commonService:CommonService
  ) {}
  show: boolean = false;

  ngOnInit(): void {
    setTimeout(() => {
      this.show = true;
    }, 0);
  }

  close(): void {
    // this.dialogRef.close();
  }
}
